import React from 'react';
import { formatDateShort } from '../../utils/screenerDataHelpers';
import '../../styles/MobileScreener.css';

/**
 * Horizontal scrollable filter for expiration dates
 * Shows "All" chip plus individual expiration date chips
 */
const ExpirationFilterChips = ({
  expirations,
  selectedExpirations,
  setSelectedExpirations,
  activeExpiration,
  setActiveExpiration
}) => {
  const handleChipClick = (expiration) => {
    if (expiration === 'all') {
      // Clear all selections (show all)
      setSelectedExpirations([]);
      setActiveExpiration('all');
    } else {
      // Toggle this expiration in the array
      setSelectedExpirations(prev => {
        if (prev.includes(expiration)) {
          // Remove it
          const newSelection = prev.filter(e => e !== expiration);
          // If nothing selected, show all
          if (newSelection.length === 0) {
            setActiveExpiration('all');
          }
          return newSelection;
        } else {
          // Add it
          setActiveExpiration(expiration); // Set as active for simulation settings
          return [...prev, expiration];
        }
      });
    }
  };

  return (
    <div className="expiration-filter">
      <div
        className={`expiration-chip ${selectedExpirations.length === 0 ? 'active' : ''}`}
        onClick={() => handleChipClick('all')}
      >
        All
      </div>
      {expirations.map(exp => (
        <div
          key={exp}
          className={`expiration-chip ${selectedExpirations.includes(exp) ? 'active' : ''}`}
          onClick={() => handleChipClick(exp)}
        >
          {formatDateShort(exp)}
        </div>
      ))}
    </div>
  );
};

export default ExpirationFilterChips;
